

export default {

    methods: {

        onStep(step, skipValidation = false) {

            if(step === 'start') {
                this.$emit('step', step)
            } else {

                if(skipValidation === false) {

                    const valid = this.$refs[this.step].validate()

                    if(!valid) {
                        return
                    }
                }

                if(step === 'submit') {
                    this.onSubmit()
                } else {

                    this.step = step

                    if(process.client) {
                        this.$scrollTo('#search-inquiry', { container: '#search-inquiry'})
                    }
                }
            }
        },

    }

}

